export enum Route {
    Actions = '/actions',
    Admin = '/admin',
    Auth = '/auth',
    AutomatedResponses = '/automated-responses',
    Automation = '/automation',
    Automation2 = '/automation2',
    Analytics = '/analytics',
    CommandCenter = '/command-center',
    CompetitiveInsights = '/competitive-insights',
    CredentialsIntermediate = '/credentials-intermediate',
    Dashboards = '/dashboards',
    Dashboards2 = '/dashboards2',
    DemoTenant = '/demo-tenant',
    Experience = '/experience',
    IdeaPortal = '/idea-portal',
    Impersonation = '/impersonation',
    Inbox = '/inbox',
    Insights = '/insights',
    Kiosk = '/kiosk',
    Labels = '/tags',
    Listings = '/listings',
    Listings2 = '/listings2',
    LocationCredentialMatcherResults = '/location-credential-matcher-results',
    Looker = '/looker',
    More = '/more',
    Onboarder = '/welcome',
    Operations = '/operations',
    QA = '/qa',
    Requests = '/requests',
    Reports = '/reports',
    Reports2 = '/reports2',
    Reports2Print = '/internal/reports2-print',
    Reviews = '/reviews',
    Reviews2 = '/reviews2',
    ReviewsUi2 = '/reviews-ui2',
    Reviews3 = '/reviews3',
    RSImpactReport = '/repscore-impact-report-2024',
    Score = '/score',
    Score2 = '/score2',
    Screenshots = '/screenshots',
    SelfService = '/self-service',
    Social = '/social',
    Social2 = '/social2',
    SocialCuration = '/social-curation',
    Surveys1 = '/legacy-surveys',
    Surveys2 = '/surveys',
    Surveys3 = '/surveys3',
    SurveysPublicUi2 = '/surveys-public-ui2',
    Tasks = '/tasks',
    UnifiedReporting = '/unified-reporting',
    Users = '/users2',
    UserVoice = '/uservoice',
    Widgets2 = '/widgets2',
    ActionPlans = '/action-plans',
    Tickets2 = '/tickets2',
    TenantActions = '/tenant-actions',
    TenantRoles2 = '/roles2',
    Skilljar = '/skilljar',
}

export const PublicRoutes: RegExp[] = [
    new RegExp(`${Route.LocationCredentialMatcherResults}`),
    new RegExp(`${Route.SelfService}`),
    new RegExp(`${Route.Screenshots}`),
    new RegExp(`${Route.Reports2Print}`),
    new RegExp(`${Route.SurveysPublicUi2}`),
    new RegExp(`${Route.Widgets2}`),
];

export const NewStackRoutes: RegExp[] = [
    new RegExp(`${Route.Admin}/.*/actions2/*`),
    new RegExp(`${Route.Admin}/.*/autofind*`),
    new RegExp(`${Route.Admin}/.*/automated-responses*`),
    new RegExp(`${Route.Admin}/.*/automation*`),
    new RegExp(`${Route.Admin}/.*/credentials2.*`),
    new RegExp(`${Route.Admin}/.*/customers/contacts(?!/import)`),
    new RegExp(`${Route.Admin}/.*/inbox*`),
    new RegExp(`${Route.Admin}/.*/rep-connect/*`),
    new RegExp(`${Route.Admin}/.*/managed-services/volume-based-mrr/*`),
    new RegExp(`${Route.Admin}/.*/profile-pages2/*`),
    new RegExp(`${Route.Admin}/.*/asset-library.*`),
    new RegExp(`${Route.Admin}/.*/listings2/sources*`),
    new RegExp(`${Route.Admin}/.*/listings2/local-search-insights/create-campaign*`),
    new RegExp(`${Route.Admin}/.*/listings2/local-search-insights/edit-campaign*`),
    new RegExp(`${Route.Admin}/.*/listings2/local-search-insights*`),
    new RegExp(`${Route.Admin}/((?!credentials).)*/sources.*`),
    new RegExp(`${Route.Admin}/sources.*`),
    new RegExp(`${Route.Admin}/.*/locations/source-integrations*`),
    new RegExp(`${Route.Admin}/.*/locations2/list*`),
    new RegExp(`${Route.Admin}/.*/tags*`),
    new RegExp(`${Route.Admin}/.*/users2.*`),
    new RegExp(`${Route.Admin}/.*/aggregate-permissions*`),
    new RegExp(`${Route.Actions}/agents}`),
    new RegExp(`${Route.Actions}/overview2}`),
    new RegExp(`${Route.Actions}/agency-tickets}`),
    new RegExp(`${Route.Actions}/lookback}`),
    new RegExp(`${Route.Actions}/mrr-dashboard}`),
    new RegExp(`${Route.Actions}/agencies/:agencyId/tenants/:tenantId/mrr-locations-dashboard`),
    new RegExp(`${Route.CommandCenter}`),
    new RegExp(`${Route.CompetitiveInsights}`),
    new RegExp(`${Route.Dashboards2}`),
    new RegExp(`${Route.Experience}/.*`),
    new RegExp(`${Route.UnifiedReporting}/.*`),
    new RegExp(`${Route.IdeaPortal}`),
    new RegExp(`${Route.Inbox}/campaigns`),
    new RegExp(`${Route.Inbox}/conversations`),
    new RegExp(`${Route.Inbox}/metrics2`),
    new RegExp(`${Route.Listings}/rich-content2`),
    new RegExp(`${Route.Listings}/traffic2`),
    new RegExp(`${Route.Listings}/accuracy2`),
    new RegExp(`${Route.Listings}/local-search-insights`),
    new RegExp(`${Route.Listings}/details-verify`),
    new RegExp(`${Route.Listings}/details2`),
    new RegExp(`${Route.Listings}/locator2`),
    new RegExp(`${Route.Listings}/pages2`),
    new RegExp(`${Route.Listings}/asset-library`),
    new RegExp(`${Route.Looker}`),
    new RegExp(`${Route.Onboarder}`),
    new RegExp(`${Route.Reports2}`),
    new RegExp(`${Route.ReviewsUi2}`),
    new RegExp(`${Route.RSImpactReport}`),
    new RegExp(`^${Route.Score2}$/`),
    new RegExp(`${Route.Screenshots}`),
    new RegExp(`${Route.SelfService}`),
    // new RegExp(`${Route.Social2}/conversations`),
    new RegExp(`${Route.Social2}/publisher`),
    new RegExp(`${Route.Surveys3}/results/.*`),
    new RegExp(`${Route.Surveys3}/templates2/.*`),
    new RegExp(`${Route.Surveys3}/dashboard2/.*`),
    new RegExp(`${Route.Surveys3}/builder2/.*`),
    new RegExp(`${Route.UserVoice}`),
    new RegExp(`${Route.Widgets2}`),
    new RegExp(`${Route.Reviews3}`),
    new RegExp(`${Route.ActionPlans}`),
    new RegExp(`${Route.Tickets2}`),
    new RegExp(`${Route.TenantRoles2}.*`),
];

export const SurveysRoute = {
    DashboardUi2: `${Route.Surveys3}/dashboard2`,
    DashboardResultsManagerUi2: `${Route.Surveys3}/dashboard2/results-manager`,
    DashboardTemplateSummaryUi2: `${Route.Surveys3}/dashboard2/summary/:surveyTemplateId`,
    DashboardTemplateIndividualResultsUi2: `${Route.Surveys3}/dashboard2/results/:surveyTemplateId`,
    PublicRunSurvey: `${Route.SurveysPublicUi2}/run/:surveyTemplateId`,
    PublicRunSurveyQuestion: `${Route.SurveysPublicUi2}/run/:surveyTemplateId/:surveyResultId/:questionId`,
    PublicRunSurveyThankYou: `${Route.SurveysPublicUi2}/thank-you/:surveyTemplateId/:surveyResultId`,
    ResultsUi2: `${Route.Surveys3}/results`,
    ResultsFeedUi2: `${Route.Surveys3}/results/feed`,
    ResultsDeepLink: `${Route.Surveys3}/results/deep-link`,
    ResultUi2: `${Route.Surveys3}/results/:surveyTemplateId/:surveyResultId`,
    ResultAttributedReviewUi2: `${Route.Surveys3}/results/:surveyTemplateId/:surveyResultId/reviews/:reviewId`,
    TemplatesOverviewUi2: `${Route.Surveys3}/templates2/all`,
    Builder2: `${Route.Surveys3}/builder2`,
    Builder2WebSurvey: `${Route.Surveys3}/builder2/web`,
    Builder2ConversationalSurvey: `${Route.Surveys3}/builder2/conversational`,
    Builder2Template: `${Route.Surveys3}/builder2/:templateId`,
    SurvesResponseApprovalYeti: `${Route.Surveys3}/results/feed/:surveyResultId`,
};
